var _a, _b, _c;
import { WidgetType } from '@common/api';
export var Period;
(function (Period) {
    Period["MONTH"] = "month";
    Period["QUARTER"] = "quarter";
    Period["HALFYEAR"] = "halfyear";
    Period["YEAR"] = "year";
    Period["YEAR_TO_DATE"] = "year to date";
})(Period || (Period = {}));
export var widgetTypeMeta = [
    { label: 'KPI', value: WidgetType.KPI },
    { label: 'Chart', value: WidgetType.CHART },
    { label: 'Single Value', value: WidgetType.SINGLEVALUE },
    { label: 'Slicer', value: WidgetType.SLICER },
    { label: 'Dimension Slicer', value: WidgetType.TAGSLICER },
    { label: 'Text Tile', value: WidgetType.TEXTTILE },
    { label: 'Pivot', value: WidgetType.PIVOT },
];
export var ConditionalFormattingValueType;
(function (ConditionalFormattingValueType) {
    ConditionalFormattingValueType["GOOD"] = "good";
    ConditionalFormattingValueType["BAD"] = "bad";
    ConditionalFormattingValueType["OFF"] = "off";
})(ConditionalFormattingValueType || (ConditionalFormattingValueType = {}));
export var ConditionalFormatting;
(function (ConditionalFormatting) {
    ConditionalFormatting[ConditionalFormatting["OFF"] = 0] = "OFF";
    ConditionalFormatting[ConditionalFormatting["TRAFFIC"] = 1] = "TRAFFIC";
    ConditionalFormatting[ConditionalFormatting["DATABAR"] = 2] = "DATABAR";
    ConditionalFormatting[ConditionalFormatting["COLORSCALE"] = 3] = "COLORSCALE";
    ConditionalFormatting[ConditionalFormatting["ARROWS"] = 4] = "ARROWS";
})(ConditionalFormatting || (ConditionalFormatting = {}));
export var conditionalFormattingOptions = [
    { label: 'Off', value: ConditionalFormatting.OFF },
    { label: 'Traffic lights', value: ConditionalFormatting.TRAFFIC },
    { label: 'Data bar', value: ConditionalFormatting.DATABAR },
    { label: 'Color scale', value: ConditionalFormatting.COLORSCALE },
    { label: 'Arrow up and down', value: ConditionalFormatting.ARROWS },
];
export var ConditionalFormattingType;
(function (ConditionalFormattingType) {
    ConditionalFormattingType[ConditionalFormattingType["RELATIVE"] = 0] = "RELATIVE";
    ConditionalFormattingType[ConditionalFormattingType["ABSOLUTE"] = 1] = "ABSOLUTE";
})(ConditionalFormattingType || (ConditionalFormattingType = {}));
export var conditionalFormattingTypeOptions = [
    { label: 'Relative', value: ConditionalFormattingType.RELATIVE },
    { label: 'Absolute', value: ConditionalFormattingType.ABSOLUTE },
];
export var decimalSeparatorsByLocale = [
    {
        locale: 'de-DE',
        separator: 'comma',
    },
    {
        locale: 'en-GB',
        separator: 'dot',
    },
];
export var comboEntry = {
    SUM: 'sum',
    AVG: 'average',
    LAST: 'last',
};
export var unitTypes = {
    FINANCE: 0,
    UNITS: 1,
    PER_UNIT: 2,
    USER_BASE: 3,
    ACQ_CHURN: 4,
    CASH: 5,
    STATE: 6,
    OTHER: 10, // => 0
};
export var unitTypeMeta = (_a = {},
    _a[unitTypes.FINANCE] = {
        name: 'Sum',
        extension: 'fin',
        periodConsolidation: comboEntry.SUM,
    },
    _a[unitTypes.UNITS] = {
        name: 'Units',
        extension: 'units',
        periodConsolidation: comboEntry.SUM,
    },
    _a[unitTypes.PER_UNIT] = {
        name: 'Average',
        extension: 'per unit',
        periodConsolidation: comboEntry.AVG,
    },
    _a[unitTypes.USER_BASE] = {
        name: 'State',
        extension: 'users',
        periodConsolidation: comboEntry.LAST,
    },
    _a[unitTypes.ACQ_CHURN] = {
        name: 'User Acquistion/Churn',
        extension: 'change',
        periodConsolidation: comboEntry.SUM,
    },
    _a[unitTypes.OTHER] = {
        name: 'Helper',
        extension: 'hlp',
        periodConsolidation: comboEntry.SUM,
    },
    _a[unitTypes.CASH] = {
        name: 'Cash flow',
        extension: 'cash',
        periodConsolidation: comboEntry.SUM,
    },
    _a[unitTypes.STATE] = {
        name: 'State',
        extension: 'state',
        periodConsolidation: comboEntry.LAST,
    },
    _a);
export var ErrorType;
(function (ErrorType) {
    ErrorType["AUTH_ERR"] = "401";
    ErrorType["NOT_FOUND"] = "404";
    ErrorType["SOCKET"] = "CONNECTION ERROR";
    ErrorType["SERVER_ERROR"] = "500";
    ErrorType["AUTH_SESSION"] = "AUTH SESSION";
})(ErrorType || (ErrorType = {}));
export var errorTypeMeta = (_b = {},
    _b[ErrorType.AUTH_ERR] = {
        code: 401,
        title: 'UNAUTHORIZED ACCESS',
        description: "You're not authorized to access the requested page.",
        returnButtonText: 'Return to dashboard',
        fn: function () { return (document.location.hash = '/dashboard'); },
    },
    _b[ErrorType.NOT_FOUND] = {
        code: 404,
        title: 'PAGE NOT FOUND',
        description: "The page that you requested doesn't exist.",
        returnButtonText: 'Return to dashboard',
        fn: function () { return (document.location.hash = '/dashboard'); },
    },
    _b[ErrorType.SOCKET] = {
        code: '',
        modalTitle: 'Connection problem',
        title: 'CONNECTION PROBLEM',
        description: 'The connection with the server was lost...',
        returnButtonText: 'Reload',
        fn: function () { return window.location.reload(); },
    },
    _b[ErrorType.SERVER_ERROR] = {
        code: '',
        modalTitle: 'Server error',
        title: 'SOMETHING WENT WRONG',
        description: 'The server encountered an error. The administrators were notified. Try' + ' reloading the application.',
        returnButtonText: 'Reload',
        fn: function () { return window.location.reload(); },
    },
    _b[ErrorType.AUTH_SESSION] = {
        code: '',
        modalTitle: 'Unauthorized access',
        title: 'OPERATION NOT PERMITTED',
        description: "Your session expired or you requested a resource for which you don't have" +
            ' the neccessary permissions.' +
            'Try reloading the application.',
        returnButtonText: 'Reload',
        fn: function () { return window.location.reload(); },
    },
    _b);
export var KpiLineFormat;
(function (KpiLineFormat) {
    KpiLineFormat[KpiLineFormat["DEFAULT"] = 0] = "DEFAULT";
    KpiLineFormat[KpiLineFormat["PERCENT_2DECIMALS"] = 1] = "PERCENT_2DECIMALS";
    KpiLineFormat[KpiLineFormat["PERCENT_WHOLE"] = 2] = "PERCENT_WHOLE";
})(KpiLineFormat || (KpiLineFormat = {}));
export var KpiColumnType;
(function (KpiColumnType) {
    KpiColumnType["SELECTOR"] = "SELECTOR";
    KpiColumnType["DIFF"] = "DIFF";
})(KpiColumnType || (KpiColumnType = {}));
export var kpiColumnTypeMeta = [
    { label: 'Regular', value: KpiColumnType.SELECTOR },
    { label: 'Calculated', value: KpiColumnType.DIFF },
];
export var KpiColumnOperation;
(function (KpiColumnOperation) {
    KpiColumnOperation["MINUS"] = "minus";
    KpiColumnOperation["DIVIDE"] = "divide";
    KpiColumnOperation["PLUS"] = "plus";
    KpiColumnOperation["MULTIPLY"] = "multiply";
    KpiColumnOperation["PERCENT"] = "percent";
    KpiColumnOperation["PERCENT_ROUNDED_THOUSANDS"] = "percent thousands";
    KpiColumnOperation["DIFF_PERCENT"] = "difference in %";
})(KpiColumnOperation || (KpiColumnOperation = {}));
export var ExpressionBlockTypes;
(function (ExpressionBlockTypes) {
    ExpressionBlockTypes["FUNCTION"] = "function";
    ExpressionBlockTypes["TAG"] = "tag$";
    ExpressionBlockTypes["LITERAL"] = "literal";
})(ExpressionBlockTypes || (ExpressionBlockTypes = {}));
export var NumberFormatType;
(function (NumberFormatType) {
    NumberFormatType["FORMATTED"] = "formatted";
    NumberFormatType["UNFORMATTED"] = "unformatted";
    NumberFormatType["TWO_DECIMALS"] = "two_decimals";
    NumberFormatType["WHOLE_NUMBERS"] = "whole";
    NumberFormatType["THOUSANDS"] = "thousands";
    NumberFormatType["THOUSANDS_WHOLE"] = "thousands_whole";
})(NumberFormatType || (NumberFormatType = {}));
export var numberFormatTypesMeta = (_c = {},
    _c[NumberFormatType.FORMATTED] = {
        label: 'Short',
    },
    _c[NumberFormatType.TWO_DECIMALS] = {
        label: 'Two Decimals',
    },
    _c[NumberFormatType.UNFORMATTED] = {
        label: 'Unformatted',
    },
    _c[NumberFormatType.WHOLE_NUMBERS] = {
        label: 'Whole Numbers',
    },
    _c[NumberFormatType.THOUSANDS] = {
        label: 'Thousands (Two Decimals)',
    },
    _c[NumberFormatType.THOUSANDS_WHOLE] = {
        label: 'Thousands (Whole Numbers)',
    },
    _c);
export var templateTypes = {
    FINDER: 0,
    TAG: 1,
    TAG_AND_FINDER: 2,
    CUSTOM_TARGET_TAG_EDIT: 3,
    CUSTOM_TARGET_TAG_DELETE: 4,
};
export var templateTypesMeta = [
    {
        value: templateTypes.FINDER,
        label: 'Finder',
    },
    {
        value: templateTypes.TAG,
        label: 'Tag',
    },
    {
        value: templateTypes.TAG_AND_FINDER,
        label: 'Tag and finder',
    },
    {
        value: templateTypes.CUSTOM_TARGET_TAG_EDIT,
        label: 'Edit targeted tag',
    },
    {
        value: templateTypes.CUSTOM_TARGET_TAG_DELETE,
        label: 'Delete targeted tag',
    },
];
export var Chart;
(function (Chart) {
    Chart[Chart["COMBINED"] = 0] = "COMBINED";
    Chart[Chart["PIE"] = 1] = "PIE";
})(Chart || (Chart = {}));
export var FormatType;
(function (FormatType) {
    FormatType[FormatType["PERCENTAGE"] = 0] = "PERCENTAGE";
    FormatType[FormatType["VALUE"] = 1] = "VALUE";
    FormatType[FormatType["CUSTOM"] = 2] = "CUSTOM";
})(FormatType || (FormatType = {}));
export var NumFmt;
(function (NumFmt) {
    NumFmt["WHOLE"] = "#,##0";
    NumFmt["TWO_DECIMALS"] = "#,##0.00";
    NumFmt["THOUSANDS"] = "#,##0,";
    NumFmt["MILLIONS"] = "#,##0,,";
    NumFmt["BILLIONS"] = "#,##0,,,";
    NumFmt["K_M_B"] = "[<999950]0.0,\"K\";[<999950000]0.0,,\"M\";0.0,,,\"B\"";
    NumFmt["PERCENT"] = "#,##0%";
    NumFmt["PERCENT_TWO_DECIMALS"] = "#,##0.00%";
})(NumFmt || (NumFmt = {}));
//Color palette
export var ColorPalette;
(function (ColorPalette) {
    ColorPalette[ColorPalette["STANDARD"] = 0] = "STANDARD";
    ColorPalette[ColorPalette["COLORBLIND"] = 1] = "COLORBLIND";
})(ColorPalette || (ColorPalette = {}));
export var Color;
(function (Color) {
    Color["GREEN"] = "#2ECC71";
    Color["BLUE"] = "#3B85FF";
    Color["RED"] = "#E74C3C";
    Color["DARK"] = "#323A44";
    Color["TEXT_DISABLED"] = "#6B83A0";
    Color["GREY_2"] = "#E7EAF0";
})(Color || (Color = {}));
export var modelDiffVersionsFormat = {
    ABSOLUTE: 0,
    PERCENT: 1,
};
export var modelDiffVersionsFormatMeta = [
    {
        value: modelDiffVersionsFormat.ABSOLUTE,
        label: 'Absolute',
    },
    {
        value: modelDiffVersionsFormat.PERCENT,
        label: 'Percent',
    },
];
export var ModelColumns;
(function (ModelColumns) {
    ModelColumns["TITLE"] = "title";
    ModelColumns["DESCRIPTION"] = "description";
    ModelColumns["MAPE"] = "mape";
    ModelColumns["MASE"] = "mase";
    ModelColumns["TAGS"] = "tags";
    ModelColumns["MONTH"] = "month";
    ModelColumns["QUARTER"] = "quarter";
    ModelColumns["HALFYEAR"] = "halfyear";
    ModelColumns["YEAR"] = "year";
    ModelColumns["YEAR_TO_DATE"] = "year to date";
    ModelColumns["SUM"] = "sum";
    ModelColumns["COMPARISON"] = "comparison";
    ModelColumns["CUSTOM_COL"] = "custom-col";
    ModelColumns["NUMBER_PROPERTY"] = "number-property";
    ModelColumns["TEXT_PROPERTY"] = "text-property";
    ModelColumns["FILE_PROPERTY"] = "file-property";
    ModelColumns["DATE_PROPERTY"] = "date-property";
})(ModelColumns || (ModelColumns = {}));
export var modelColumnsMeta = [
    {
        value: ModelColumns.DESCRIPTION,
        label: 'Description',
    },
    {
        value: ModelColumns.MAPE,
        label: 'MAPE',
    },
    {
        value: ModelColumns.MASE,
        label: 'MASE',
    },
];
